import { getBaseRole } from '@/helpers/customRoles';
const CHILDREN_FIELDS = ['children', 'linked_children', 'parent_children']

const normalizeRole = (value) => {
  if (value && typeof value === 'object') {
    return String(value.value ?? value.name ?? value.role ?? '').toLowerCase()
  }

  return String(value ?? '').toLowerCase()
}

const getChildName = (child) => {
  if (typeof child === 'string') return child.trim()
  if (!child || typeof child !== 'object') return ''

  return String(
    child.name ?? child.full_name ?? child.fullName ?? child.label ?? '',
  ).trim()
}

export const getParentChildrenInfo = (member) => {
  if (!member || typeof member !== 'object') {
    return { isParent: false, hasChildrenData: false, childrenNames: [] }
  }

  const memberWithChildren = member.user && typeof member.user === 'object'
    ? { ...member.user, ...member }
    : member
  const childrenField = CHILDREN_FIELDS.find((field) =>
    Object.prototype.hasOwnProperty.call(memberWithChildren, field),
  )
  const children = childrenField && Array.isArray(memberWithChildren[childrenField])
    ? memberWithChildren[childrenField]
    : []
  const role = normalizeRole(
    memberWithChildren.platform_role ??
    memberWithChildren.user_role ??
    memberWithChildren.role_name ??
    memberWithChildren.user?.role,
  )

  return {
    isParent: getBaseRole(role) === 'parent' || Boolean(childrenField),
    hasChildrenData: Boolean(childrenField),
    childrenNames: children.map(getChildName).filter(Boolean),
  }
}
